import { render, staticRenderFns } from "./auditorium_list.vue?vue&type=template&id=f8ae5b6c&"
import script from "./auditorium_list.vue?vue&type=script&lang=js&"
export * from "./auditorium_list.vue?vue&type=script&lang=js&"
import style0 from "./auditorium_list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports